const fakePagination = () => {

    //vars
    var currentPage = 1;
    var pages = document.querySelector('.fake-pagination__pagination').dataset.pages;
    var group = document.querySelectorAll('.fake-pagination__group');
    let links = document.querySelectorAll('.fake-pagination__pagination-link');
    let linkPrev = document.querySelector('.fake-pagination__pagination .pagination-prev');
    let linkNext = document.querySelector('.fake-pagination__pagination .pagination-next');

    //Functions
    function changePage(page) {
        if (page <= 1) {
            page = 1
            linkPrev.classList.add('d-none');
        }else{
            linkPrev.classList.remove('d-none');
        }
        if (page > pages) page = pages
        if (page >= pages){
            linkNext.classList.add('d-none');
        }else{
            linkNext.classList.remove('d-none');
        }
        links.forEach(element => {
            if(element.classList.contains('pagination-current')){
                element.classList.remove('pagination-current')
            }
        });
        group.forEach(element => {
            if(element.classList.contains('d-flex')){
                element.classList.remove('d-flex')
                element.classList.add('d-none')
            }
        });
        group[currentPage - 1].classList.remove('d-none')
        group[currentPage - 1].classList.add('d-flex')
        links[currentPage - 1].classList.add('pagination-current')
    }
    function nextPage() {
        if (currentPage < pages) changePage(++currentPage)
    }
    function prevPage() {
        if (currentPage > 1) changePage(--currentPage)
    }
    function gotoPage(page) {
        currentPage = page
        changePage(page)
    }

    //triggers
    links.forEach(element => {
        element.addEventListener('click', (event) => {
            event.preventDefault;
            let anchor = parseInt(element.dataset.anchor);
            gotoPage(anchor);
        })
    });
    linkPrev.addEventListener('click', () => {
        prevPage();
    })
    linkNext.addEventListener('click', () => {
        nextPage();
    })

    window.onload = function () {
        changePage(1) // set default page
    };
}
export default fakePagination;